import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { logoutUser } from '../../utils/auth';
import { IconsVariants } from '../../UI';
import { Links, LinksVariants } from '../../UI/Links/Links';


export const Navigation: React.FC = () => {

  const location = useLocation();

  const navigate = useNavigate();
  const userId = localStorage.getItem('userId');

  const userIsLogged = !!userId;

  const onLogout = (_e: React.MouseEvent) => {
    logoutUser();
    navigate('/');
    window.location.reload();
  };

  const onHomeClick = (e: React.MouseEvent) => {
    // If we're already on the home page, reload it
    if (location.pathname === '/') {
      e.preventDefault();
      window.location.reload();
    }
    // Otherwise, let React Router handle the navigation normally
  };


  return (
    <nav className='no-scrollbar flex flex-1'>
      <ul className='flex-1' >
        <li>
          <Links
            variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
            iconVariant={IconsVariants.HOME_FULL}
            to={`/`}
            text='Home'
            onClick={onHomeClick}
          />
        </li>
        <li>
          <Links
            variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
            iconVariant={IconsVariants.INFO}
            to={`/about`}
            text='What is Pinion?'
          />
        </li>
        {
          userIsLogged
            ?
            <li>
              <Links
                variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                iconVariant={IconsVariants.LAYER}
                to={`/user-questions/${userId}`}
                text='My pinions'
              />
            </li>
            : null
        }
        {
          userIsLogged
            ?
            <>
              <li>
                <Links
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.PLUS_SQUARE}
                  to={`/create-pinion`}
                  state={{ backgroundLocation: location }}
                  text='New pinion'
                />
              </li>
              <li>
                <Links
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.BOOKMARK_FULL}
                  to={`/bookmarks`}
                  text='Bookmarks'
                />
              </li>
              <li>
                <Links
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.HEART_FULL}
                  to={`/soulmates`}
                  text='Soulmates'
                />
              </li>
              <li>
                <Links
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.BELL_FULL}
                  to={`/notifications`}
                  text='Notifications'
                />
              </li>
              <li>
                <Links
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.PROFILE_FULL}
                  to={`/profile/${userId}`}
                  text='Profile'
                />
              </li>
              <li>
                <Links
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.POWER_OFF}
                  text='Logout'
                  to={'/logout'}
                  onClick={onLogout}
                  preventNavigation={true}
                />
              </li>
            </>
            : null
        }
        {
          !userIsLogged
            ? <>
              <li>
                <Links
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.USER_FULL}
                  text='Login'
                  to={'/login'}
                  state={{ backgroundLocation: location }}
                />
              </li>
              <li>
                <Links
                  variant={LinksVariants.BOUNCING_ICON_WITH_TEXT}
                  iconVariant={IconsVariants.ID_CARD}
                  text='Register'
                  to={'/register'}
                  state={{ backgroundLocation: location }}
                />
              </li>
            </>
            : null
        }
      </ul>
    </nav>
  );
};
